import { render, staticRenderFns } from "./warn-icon.vue?vue&type=template&id=b5f96440"
import script from "./warn-icon.vue?vue&type=script&lang=js"
export * from "./warn-icon.vue?vue&type=script&lang=js"
import style0 from "./warn-icon.vue?vue&type=style&index=0&id=b5f96440&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports